function setDocumentDescription(description: string) {
  const descriptionMetaElement = document.querySelector<HTMLMetaElement>(
    'meta[name="description"]',
  );
  if (!descriptionMetaElement) {
    const metaElement = document.createElement('meta');
    metaElement.setAttribute('name', 'description');
    metaElement.content = description;
    document.getElementsByTagName('head')[0].appendChild(metaElement);
  } else {
    descriptionMetaElement.content = description;
  }
}

export const useSetDocumentDescription = () => (description: string) => {
  setDocumentDescription(description);
};
